// @flow

import styled from "@emotion/styled";

import { ChatHistory } from "src/components/messages/styles";
import DefaultModal from "src/styles/modal";
import { Form } from "src/styles/form";
import * as spacing from "src/styles/constants/spacing";
import * as colors from "src/styles/constants/colors";
import { highlightBorder } from "src/styles";

const Modal = styled(DefaultModal)`
  > div > div > .ReactModal__Content {
    top: 40px !important;
    height: 85%;
    background: ${colors.appBackground} !important;
    > div {
      display: flex;
      flex-direction: column;
    }
  }
  ${ChatHistory} {
    height: calc(100% - 189px);
  }
`;

export default Modal;

export const Close = styled.div`
  cursor: pointer;
  position: absolute;
  right: 1rem;
  top: 1rem;
`;

export const Launch = styled.div`
  position: absolute;
  right: 1rem;
  bottom: 0.5rem;
  padding: ${spacing.space_xs};
  svg {
    padding-left: ${spacing.space_s};
  }
`;

export const HeaderInfo = styled.div`
  display: flex;
  align-items: center;
  > div {
    margin-right: 24px;
  }
`;

export const Warning = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 888;
  background-color: ${colors.overlay} !important;
`;

export const WarningForm = styled(Form)`
  z-index: 999;
  position: absolute;
  background-color: ${colors.brightLight};
  top: 30%;
  left: 45%;
  bottom: 50%;
  height: 10.4em;
  min-width: 10px;
  width: 28em;
  > h4 {
    font-weight: bold;
  }
`;

export const ModalFormBody = styled.div`
  background: ${colors.brightLight};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  border: none;
  > span {
    display: block;
    background-color: ${colors.brightLight};
    font-weight: normal;
    font-size: 0.781rem;
    padding: 1em 1.25em 0 1.25em;
    > a {
      padding-left: 0.3em;
      padding-right: 0.3em;
    }
  }
`;

export const ModalContent = styled.div`
  ${(props) => props.isDragActive && highlightBorder};
`;
